import classNames from "clsx";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

import { Loading } from "react-migration/components/Loading";

import { FinalStepWrapper } from "./FinalStepWrapper";

export const LetterLoading = () => {
  const { t } = useTranslation();

  return (
    <FinalStepWrapper>
      <div className="mb-3">
        <Loading />
      </div>
      <span className={classNames("my-4", "text-content", "font-semibold", "text-xl", "leading-7")}>
        {t("sites.letters.preparing_letters")}
      </span>
    </FinalStepWrapper>
  );
};
